import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Webinar.css";

const ReactionTestEntry = () => {

  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [registered, setRegistered] = useState(false);
  const [statusMsg, setStatusMsg] = useState("⏳ Waiting for test to start...");

  /* ================= CHECK LOCAL STORAGE ================= */

  useEffect(() => {
    if (localStorage.getItem("reaction_user")) {
      setRegistered(true);
    }
  }, []);

  /* ================= POLLING ================= */

  useEffect(() => {

    if (!registered) return;

    const interval = setInterval(async () => {

      try {

        const res = await axios.get("/api/test-status", {
          params: { email: localStorage.getItem("rg_email") }
        });

        if (res.data.status === "waiting") {
          setStatusMsg("⏳ Waiting for host...");
        }

        if (res.data.status === "completed") {
          setStatusMsg("❌ Already attempted");
          clearInterval(interval);
        }

        if (res.data.status === "allowed") {

          // 🔥 mark played before entering
          await axios.post("/api/mark-played", {
            email: localStorage.getItem("rg_email")
          });

          navigate("/reaction");
        }

      } catch (err) {
        console.error("Status error:", err);
      }

    }, 2000);

    return () => clearInterval(interval);

  }, [registered, navigate]);

  /* ================= REGISTER ================= */

  const handleRegister = async () => {

    if (!name || !email) {
      alert("Please enter all details");
      return;
    }

    if (!email.includes("@")) {
      alert("Enter valid email");
      return;
    }

    try {

      await axios.post("/api/reaction-register", {
        name,
        email
      });

      // 🔥 Save for session
      localStorage.setItem("reaction_user", "true");
      localStorage.setItem("rg_name", name);
      localStorage.setItem("rg_email", email);

      setRegistered(true);

    } catch (err) {
      console.error("Register error:", err);
      alert("Registration failed");
    }
  };

  /* ================= FORM UI ================= */

  if (!registered) {
    return (
      <div style={{ textAlign: "center", marginTop: "100px" }}>
        <h2>⚡ Reaction Test Entry</h2>

        <input
          type="text"
          placeholder="Enter Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          style={{ padding: "10px", width: "250px" }}
        />

        <br /><br />

        <input
          type="email"
          placeholder="Enter Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ padding: "10px", width: "250px" }}
        />

        <br /><br />

        <button
          onClick={handleRegister}
          style={{
            padding: "10px 20px",
            cursor: "pointer",
            background: "#28a745",
            color: "#fff",
            border: "none",
            borderRadius: "5px"
          }}
        >
          Enter Webinar
        </button>
      </div>
    );
  }

  /* ================= WAITING UI ================= */

  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h2>⚡ Reaction Test</h2>
      <p>{statusMsg}</p>
    </div>
  );
};

export default ReactionTestEntry;